import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-line bg-white/95 shadow-sm backdrop-blur" data-id="element-236" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-white sm:text-xs md:text-sm" data-id="element-237" data-mp="1y30urred79g5">
        🇦🇷 EL SISTEMA COMPLETO PARA ENTRENADORES DE POWERLIFTING EN ARGENTINA
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-slate-500 md:flex" data-id="element-238" data-mp="2qroidtml6awv">
        <span className="flex items-center gap-1.5" data-id="element-239" data-mp="2h2of3y11wtcv">
          <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-240" data-mp="2h13m4cudxih4" /> Acceso en 5 minutos
        </span>
        <span className="text-primary/30" data-id="element-241" data-mp="2c2se87nnhi1j">·</span>
        <span className="flex items-center gap-1.5" data-id="element-242" data-mp="39iz7c58r4dm4">
          <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-243" data-mp="39kk2nx2w40l1" /> Pago seguro
        </span>
        <span className="text-primary/30" data-id="element-244" data-mp="34r7nedk3p64y">·</span>
        <span className="flex items-center gap-1.5" data-id="element-245" data-mp="34qfwhg1g7wl0">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-246" data-mp="26ivlvw1xx2r" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}